export const DEACTIVATE_DP_ENUM = "deactivated";
